import React from 'react';
import TpClientInvoiceItem from '../../../Domain/TpClientInvoiceItem';
import TpClientInvoiceService from '../../../Services/TpClientInvoiceService';
import TpClientInvoiceSearchParams from './TpClientInvoiceSearchParams';
import ShownPanelsEnum from '../../../Enums/ShownPanelsEnum';
import TabOfDataTable from '../../../Elements/DataTable/TabOfDataTable';
import CrudTypesEnum from '../../../Enums/CrudTypesEnum';
import GeneralEditWizzardBase from '../../../Elements/GeneralEditWizzard/GeneralEditWizzardBaseFigma';
import contactService from '../../../Services/contactService';
import ErrorMessage from '../../../Elements/ErrorMessage';
import OrderDirectionsEnum from '../../../Enums/OrderDirectionsEnum';
import dateTimeHelper from '../../../Helpers/datetimeHelper';
import FinalizeTpClientInvoiceWindowDescription from './FinalizeTpClientInvoiceWindowDescription';
import ButtonTypeEnum from '../../../Enums/ButtonTypeEnum';
import ButtonColorsEnum from '../../../Enums/ButtonColorsEnum';
import IconPositionEnum from '../../../Enums/IconPositionEnum';
import FigmaButtonRow from '../../../Elements/FigmaButtonRow';
import FinalizeTpClientInvoiceBulkItem from '../../../Domain/FinalizeTpClientInvoiceBulkItem';
import FinalizeTpClientInvoiceBulkWindowDescription from './BulkFinalizeClientInvoiceDesciption';
import EditTpClientInvoiceWindowDescription from './EditTpClientInvoiceWindowDescription';
import ExportTpClientInvoicePdfsWindowDescription from './ExportTpClientInvoicePdfsWindowDescription';
import ExportTpClientInvoicePdfsItem from '../../../Domain/ExportTpClientInvoicePdfsItem';
import EditTpCreditMemoWindowDescription from '../TpCreditMemo/EditTpCreditMemoWindowDescription';
import TpCreditMemoItem from '../../../Domain/CreditMemo/TpCreditMemoItem';

export default class TpClientInvoiceAdmin extends React.Component {
  constructor(props) {
    super(props);

    const urlParams = new URLSearchParams(window.location.search);

    this.state = {
      shownPanel: ShownPanelsEnum.None,
      // Deep-link seed for global record search (CD-5425), on the invoice's own id so the grid lands on
      // the one row the palette displayed.
      //
      // Like the ClientNameOrId seed below it, this REPLACES the search item rather than extending it, and
      // that is load-bearing rather than tidy: TpClientInvoiceSearchParams defaults both a status filter and the
      // user's office. A seeded invoice in another status or another office would be filtered straight back
      // out, and the deep link would look broken while in fact working perfectly.
      searchItem: urlParams.get('TpClientInvoiceId')
        ? { TpClientInvoiceId: urlParams.get('TpClientInvoiceId') }
        : urlParams.get('ClientNameOrId')
        ? { ClientNameOrId: urlParams.get('ClientNameOrId') }
        : new TpClientInvoiceSearchParams(),
      allItemsInTheSearchSetAreSelected: false,
      itemList: [],
      numberOfElementsInTheTable: 0,
      selectedItem: {},
      copyItem: {},
    };

    this.startSearch = this.startSearch.bind(this);
    this.refresh = this.refresh.bind(this);

    TpClientInvoiceItem.editFunction = this.editInvoiceFunction.bind(this);
    TpClientInvoiceItem.cancelFunction = this.cancelInvoiceFunction.bind(this);
    TpClientInvoiceItem.finalizeFunction = this.finalizeInvoiceFunction.bind(this);
    TpClientInvoiceItem.createCreditMemoFunction = this.createCreditMemoFunction.bind(this);
    TpClientInvoiceItem.copyFunction = this.copyFunction.bind(this);

    ExportTpClientInvoicePdfsWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    ExportTpClientInvoicePdfsWindowDescription.getSelected = this.getSelected.bind(this);
    ExportTpClientInvoicePdfsWindowDescription.getAllItemsInTheSearchSetAreSelected =
      this.getAllItemsInTheSearchSetAreSelected.bind(this);
    FinalizeTpClientInvoiceBulkWindowDescription.getSearchParameters = this.getSearchParameters.bind(this);
    FinalizeTpClientInvoiceBulkWindowDescription.getSelected = this.getSelected.bind(this);
    FinalizeTpClientInvoiceBulkWindowDescription.getAllItemsInTheSearchSetAreSelected =
      this.getAllItemsInTheSearchSetAreSelected.bind(this);

    this.callCancelInvoiceFunction = this.callCancelInvoiceFunction.bind(this);
    this.finalizeSelectedFunction = this.finalizeSelectedFunction.bind(this);
    this.handleExportExcelButtonClick = this.handleExportExcelButtonClick.bind(this);
    this.exportInvoicePdfs = this.exportInvoicePdfs.bind(this);
  }

  getAllItemsInTheSearchSetAreSelected() {
    return this.state.allItemsInTheSearchSetAreSelected;
  }

  getSearchParameters() {
    return this.state.searchItem;
  }

  getSelected() {
    return this.state.itemList.filter((u) => u.Selected === true);
  }

  startSearch(searchItem) {
    this.setState({ searchItem: { ...searchItem } });
  }

  refresh(refresh) {
    if (refresh) {
      this.setState({ shownPanel: ShownPanelsEnum.None, searchItem: { ...this.state.searchItem } });
    } else this.setState({ shownPanel: ShownPanelsEnum.None });
  }

  renderOnePanel(panelId, content) {
    return this.state.shownPanel === panelId ? content : null;
  }

  editInvoiceFunction(selectedId, selectedItem) {
    selectedItem.isEditing = true;
    if (selectedItem.Vatnumber === ' ') selectedItem.Vatnumber = '';
    contactService
      .GetContactListByClientId(selectedItem.CaspianClientId, true, true)
      .then((contacts) => {
        selectedItem.ClientContacts = contacts;
        this.setState({
          selectedItem,
          shownPanel: ShownPanelsEnum.EditItem,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPCIA89', error));
  }

  copyFunction(selectedId, selectedItem) {
    const copyItem = { ...selectedItem };
    copyItem.TpClientInvoiceId = null;
    copyItem.IsCopyAction = true;
    if (copyItem.Vatnumber === ' ') copyItem.Vatnumber = '';
    contactService
      .GetContactListByClientId(copyItem.CaspianClientId, true, true)
      .then((contacts) => {
        copyItem.ClientContacts = contacts;
        this.setState({
          copyItem,
          shownPanel: ShownPanelsEnum.AddNewItem,
        });
      })
      .catch((error) => ErrorMessage.SetErrorMessage('TPCIA89', error));
  }

  cancelInvoiceFunction(selectedId, selectedItem) {
    ErrorMessage.SetWarningWithComment(
      `You are about to cancel this invoice (${selectedId}). Are you sure?`,
      'Comment:',
      (comment) => {
        this.callCancelInvoiceFunction(selectedId, selectedItem, comment);
      },
      'Yes',
      'No'
    );
  }

  callCancelInvoiceFunction(selectedId, selectedItem, comment) {
    if (selectedItem.Count > 500) {
      TpClientInvoiceService.CancelInvoice(selectedId, selectedItem, comment).catch((error) => {
        ErrorMessage.SetErrorMessage('CIA65', error);
      });

      ErrorMessage.SetNotification(
        'Started cancelling the invoice in the background. You will receive an in-app notification when the process is done.'
      );
      return;
    }

    TpClientInvoiceService.CancelInvoice(selectedId, selectedItem, comment)
      .then((result) => {
        if (result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else {
          ErrorMessage.SetNotification('Invoice set to cancelled.');
          ErrorMessage.SetLoading(false);
          this.refresh(true);
        }
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('CIA65', error);
        ErrorMessage.SetLoading(false);
      });
    ErrorMessage.SetLoading(true);
  }

  finalizeInvoiceFunction(selectedId, selectedItem) {
    const lowerLimit = new Date(dateTimeHelper.toYYYYsMMsDD(dateTimeHelper.addDaysToDate(new Date(), 1)));
    if (selectedItem.OfficeId === 9 && new Date(selectedItem.FulfillmentDate) < lowerLimit)
      selectedItem.FulfillmentDate = dateTimeHelper.addDaysToDate(new Date(), 1);
    this.setState({
      selectedItem,
      shownPanel: ShownPanelsEnum.Finalize,
    });
  }

  finalizeSelectedFunction() {
    const selectedItem = new FinalizeTpClientInvoiceBulkItem();

    TpClientInvoiceService.FinalizeSelectedInvoice(
      selectedItem,
      this.getSearchParameters(),
      this.getSelected(),
      this.getAllItemsInTheSearchSetAreSelected()
    )
      .then((result) => {
        if (result && result.specialError) {
          ErrorMessage.SetWarning(result.specialError);
        } else if (result && result.error) {
          ErrorMessage.SetErrorMessage(result.error);
        } else if (result && result.result) {
          ErrorMessage.SetNotification('Partial success. You have got a message with the details.');
        } else {
          ErrorMessage.SetNotification('Invoice(s) finalized.');
        }
        ErrorMessage.SetLoading(false);
        this.refresh(true);
      })
      .catch((error) => {
        ErrorMessage.SetErrorMessage('TPCIA188', error);
        ErrorMessage.SetLoading(false);
        this.refresh(false);
      });
    ErrorMessage.SetLoading(true);
  }

  createCreditMemoFunction(selectedId, selectedItem) {
    const item = new TpCreditMemoItem();
    item.TpClientInvoiceId = selectedItem.TpClientInvoiceId;
    item.CaspianClientId = selectedItem.CaspianClientId;
    item.FromClientInvoice = true;
    this.setState({
      selectedItem: item,
      shownPanel: ShownPanelsEnum.CreateCreditMemo,
    });
  }

  exportInvoicePdfs() {
    if (
      (this.state.allItemsInTheSearchSetAreSelected && this.state.numberOfElementsInTheTable > 50) ||
      this.getSelected().length > 50
    ) {
      ErrorMessage.SetWarning(
        'Number of selected elements is over 50, which is the current upper limit to a single export.'
      );
      return;
    }

    this.setState({ shownPanel: ShownPanelsEnum.Export, selectedItem: new ExportTpClientInvoicePdfsItem() });
  }

  handleExportExcelButtonClick() {
    TpClientInvoiceService.ExportAdminExcelAsync(this.state.searchItem).catch(() =>
      ErrorMessage.SetErrorMessage('TPCA202')
    );
    ErrorMessage.SetSuccessWithWait(
      'File creation has started and your report will be available in your personal download menu soon. You can continue to use the system while your request is being processed.'
    );
  }

  renderPanels() {
    return (
      <div>
        {this.renderOnePanel(
          ShownPanelsEnum.EditItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditTpClientInvoiceWindowDescription}
            errorCode='TPCIA232'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Finalize,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={FinalizeTpClientInvoiceWindowDescription}
            errorCode='TPCIA243'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.BulkFinalize,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={new FinalizeTpClientInvoiceBulkItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={FinalizeTpClientInvoiceBulkWindowDescription}
            errorCode='TPCIA241'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.Export,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Update}
            editedItem={new FinalizeTpClientInvoiceBulkItem()}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={ExportTpClientInvoicePdfsWindowDescription}
            errorCode='TPCIA252'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.CreateCreditMemo,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.selectedItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={this.refresh}
            windowDescription={EditTpCreditMemoWindowDescription}
            errorCode='CIA247'
          />
        )}
        {this.renderOnePanel(
          ShownPanelsEnum.AddNewItem,
          <GeneralEditWizzardBase
            crudType={CrudTypesEnum.Create}
            editedItem={this.state.copyItem}
            clickOnCancel={() => this.setState({ shownPanel: ShownPanelsEnum.None })}
            clickOnSave={() => this.refresh(true)}
            windowDescription={EditTpClientInvoiceWindowDescription}
            errorCode='TPCIA232'
          />
        )}
      </div>
    );
  }

  getApproveMessage() {
    if (this.state.allItemsInTheSearchSetAreSelected) {
      return `Finalize all currently selected (${this.state.numberOfElementsInTheTable}) Client Invoices?`;
    }
    const idList = this.state.itemList
      .filter((x) => x.Selected === true)
      .map((x) => x.TpClientInvoiceId)
      .join(', ');
    return `Finalize the selected Client Invoice(s)? (ids: ${idList})`;
  }

  renderButtonsAndPanels() {
    return (
      <div>
        <FigmaButtonRow
          buttons={[
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: this.exportInvoicePdfs,
              label: 'Export Invoice PDFs',
              tooltip: 'Export TpClientInvoice PDFs',
              // roleKey: 'tpclientinvoices_view',
              disabled: this.getSelected().length === 0,
            },
            {
              type: ButtonTypeEnum.NormalNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => ErrorMessage.SetApprove(this.getApproveMessage(), this.finalizeSelectedFunction),
              label: 'Finalize Selected',
              tooltip: 'Finalize Selected',
              roleKey: 'tpclientinvoices_edit',
              disabled: this.getSelected().length === 0,
            },
            {
              type: ButtonTypeEnum.ExtraLargeNormal,
              color: ButtonColorsEnum.Secondary,
              iconPosition: IconPositionEnum.None,
              onClick: () => this.setState({ shownPanel: ShownPanelsEnum.BulkFinalize }),
              label: 'Invoice Bulk Finalization',
              tooltip: 'Invoice Bulk Finalization',
              roleKey: 'tpclientinvoices_bulkfinalize',
            },
          ]}
        />
        {this.renderPanels()}
      </div>
    );
  }

  render() {
    return (
      <div className='contentwrapper'>
        {this.renderButtonsAndPanels()}
        <TabOfDataTable
          type={TpClientInvoiceItem}
          serviceFunction={TpClientInvoiceService.GetListBySearching}
          convertDBItemsFunction={TpClientInvoiceService.ConvertDBItems}
          orderBy='TpClientInvoiceId'
          orderDirection={OrderDirectionsEnum.Desc}
          shownPanel={this.state.shownPanel}
          clickOnStartSearch={this.startSearch}
          searchItem={this.state.searchItem}
          searchParamsType={TpClientInvoiceSearchParams}
          showSearchStrip={true}
          singleSearchLine={true}
          singleSearchLinePlaceholder='Search in client id & name, po #, invoice numbers...'
          isExportExcelDisabled={false}
          clickOnExportExcel={this.handleExportExcelButtonClick}
          excelExportRoleKey='tpclientinvoices_edit'
          changeOfItemListFunction={(itemList, numberOfElementsInTheTable) =>
            this.setState({ itemList, numberOfElementsInTheTable })
          }
          changeOfAllItemsAreSelectedFunction={(allItemsInTheSearchSetAreSelected) => {
            this.setState({ allItemsInTheSearchSetAreSelected });
          }}
          errorCode='TPCIA349'
        />
      </div>
    );
  }
}
